/* eslint-disable no-console */
import { isPluginMode } from './isPluginMode';
import { getSearchParamOnPluginURL } from './queryString';

type LDFlags = {
  keys: string[];
  values: { value: boolean | { [key: string]: string } }[];
}

export const fieldViewArchRedirect = (flags: LDFlags) => {
  const scriptCreatorFlag = flags.keys.includes('script-creator-plugin-version')
    && flags.values[flags.keys.indexOf('script-creator-plugin-version')].value;
  const currentPath = window.location.pathname;
  const currentHash = window.location.hash;
  
  const clientId = `?client-id=${getSearchParamOnPluginURL('client-id')}` || '';
  const params = isPluginMode()
    ? currentHash.slice('#/variable-rate'.length).replace(clientId, '')
    : currentHash.slice(1);

  const isGlobalExp = currentPath.includes('/global/exp');

  const redirectVariableRatePlugin = `/static/field-view/#/variable-rate${params}`;
  const redirectVariableRateSpa = `/variable-rate/index.html${clientId}#${params}`;

  const variableRateSpa = '/variable-rate/index.html';

  const isSPAVersion = currentPath.includes(variableRateSpa);
  const isFieldViewArch = currentPath.includes('/static/field-view');

  if (!isGlobalExp) {
    // It will consider if it is exp link
    if (isSPAVersion && scriptCreatorFlag) {
      // This case means that the application is Variable Rate as SPA and new Arch flag is true
      window.location.replace(redirectVariableRatePlugin);

    } else if (isFieldViewArch && !scriptCreatorFlag) {
      // This case means that the application is Variable Rate as Plugin and new Arch flag is false
      window.location.replace(redirectVariableRateSpa);
    }
  }
};
